import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { useToast } from "@/components/ui/use-toast";
import { useAuth } from "@/context/AuthContext";

export function InviteMembersDialog({ open, onOpenChange, organizationSlug, onInvitesSent }) {
  const [emails, setEmails] = useState("");
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();
  const { axiosInstance } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const emailList = emails
        .split(',')
        .map(email => email.trim())
        .filter(Boolean);

      await axiosInstance.post(`/organizations/${organizationSlug}/invites`, {
        emails: emailList
      });

      toast({
        description: "Invitations sent successfully",
      });

      setEmails("");
      onOpenChange(false);
      if (onInvitesSent) {
        onInvitesSent();
      }
    } catch (error) {
      console.error('Error sending invites:', error);
      toast({
        description: "Failed to send invitations",
        variant: "destructive"
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Invite Team Members</DialogTitle>
          <DialogDescription>
            Invite people to join your organization. Enter email addresses separated by commas.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label htmlFor="emails">Email Addresses</Label>
              <Textarea
                id="emails"
                placeholder="e.g. john@example.com, jane@example.com"
                value={emails}
                onChange={(e) => setEmails(e.target.value)}
              />
            </div>
          </div>
          <DialogFooter>
            <Button type="submit" disabled={loading}>
              {loading ? "Sending..." : "Send Invites"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
} 